import { FC } from 'react';
import { WbCard, WbCardContent } from '@agilelab/plugin-wb-platform';
import { EntityListProvider } from '@backstage/plugin-catalog-react';
import { useTheme } from '@material-ui/core';
import { ComponentsTable } from './ComponentsTable/ComponentsTable';
import { LatestProvisioning } from './LatestProvisioningAccordion/LatestProvisioning';
import { ProvisioningCardActions } from './ProvisioningCardActions';
import { QuickLinks } from './QuickLinks';

export const ProvisioningCard: FC = () => {
  const theme = useTheme();
  return (
    <EntityListProvider>
      <WbCard
        cardStyle={{ display: 'block' }}
        title="Provisioning"
        actions={<ProvisioningCardActions />}
      >
        <WbCardContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
          }}
        >
          <LatestProvisioning />
          <QuickLinks />
          <ComponentsTable />
        </WbCardContent>
      </WbCard>
    </EntityListProvider>
  );
};
